module.exports = __webpack_public_path__ + "static/media/proposal_dropoff_pin.ecc7a697.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/flavours/via/images/proposal_dropoff_pin.svg
// module id = 482
// module chunks = 0